import { supabase } from './supabaseClient';

let _cachedAuthHeader = null;
let _cachedAuthHeaderAt = 0;
const AUTH_HEADER_CACHE_MS = 3000;

export async function getAuthHeaders(extraHeaders = {}) {
  const now = Date.now();
  if (_cachedAuthHeader && (now - _cachedAuthHeaderAt) < AUTH_HEADER_CACHE_MS) {
    return {
      ..._cachedAuthHeader,
      ...extraHeaders,
    };
  }

  const { data } = await supabase.auth.getSession();
  const token = data.session?.access_token;

  if (!token) {
    _cachedAuthHeader = null;
    _cachedAuthHeaderAt = 0;
    throw new Error('NOT_AUTHENTICATED');
  }

  _cachedAuthHeader = { Authorization: `Bearer ${token}` };
  _cachedAuthHeaderAt = now;

  return {
    ..._cachedAuthHeader,
    ...extraHeaders,
  };
}
